module.exports = __webpack_public_path__ + "static/media/3.8879d5d1.png";